import { ContraventionProcessingJobStatus } from '@EcamModel/model';

export enum BackdatingMode {
    MANUAL_REVIEW,
    AUTO_ENQUEUE,
}

export const statusBackdateOptions = [
    { Id: BackdatingMode.MANUAL_REVIEW, Name: 'Manual Review' },
    { Id: BackdatingMode.AUTO_ENQUEUE, Name: 'Enqueued' },
];

export const backdateStatusMapping = {
    [ContraventionProcessingJobStatus.Pending]: 'Pending',
    [ContraventionProcessingJobStatus.InProgress]: 'In Progress',
    [ContraventionProcessingJobStatus.Completed]: 'Completed',
    [ContraventionProcessingJobStatus.Failed]: 'Failed',
    [ContraventionProcessingJobStatus.PartialCompleted]: 'Partially Completed',
};

export const statusContraventionReviewSessionOptions = [
    { Id: ContraventionProcessingJobStatus.Pending, Name: 'Pending' },
    { Id: ContraventionProcessingJobStatus.InProgress, Name: 'In Progress' },
    { Id: ContraventionProcessingJobStatus.Completed, Name: 'Completed' },
    { Id: ContraventionProcessingJobStatus.Failed, Name: 'Failed' },
    { Id: ContraventionProcessingJobStatus.PartialCompleted, Name: 'Partially Completed' },
];

export const capitalizeFirst = (str: string) => (str ? str[0].toLocaleUpperCase() + str.slice(1) : str);
